import { ConsumerHandshake, HostHandshake } from '../Handshake';

export abstract class AbstractHostEndpoint {
  abstract handshake: HostHandshake;

  get onConnect() {
    return this.handshake.onHandshake.bind(this.handshake);
  }
}

export abstract class AbstractConsumerEndpoint {
  abstract handshake: ConsumerHandshake;

  get onConnect() {
    return this.handshake.onHandshake.bind(this.handshake);
  }
}
